/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { Colors, Shapes } from 'src/components/theme'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { Info } from '@emotion-icons/fa-solid/Info'
import { RankIcon } from 'src/components/insights/icons/rank'
import { UnavailableMobility } from 'src/components/insights/unavailable-mobility'
import InsightLocked from 'src/components/insight-locked'
import { useTier } from 'src/hooks/use-tier'

import rank1 from 'src/assets/images/insights-previews/rank/rank_1.gif'
import rank1Placeholder from 'src/assets/images/insights-previews/rank/rank_1.png'
import rank2 from 'src/assets/images/insights-previews/rank/rank_2.gif'
import rank2Placeholder from 'src/assets/images/insights-previews/rank/rank_2.png'
import rank3 from 'src/assets/images/insights-previews/rank/rank_3.gif'
import rank3Placeholder from 'src/assets/images/insights-previews/rank/rank_3.png'
import { INSIGHTS_TIER } from 'src/constants/insights-tier'
import { GenericLoader } from 'src/v2/components/skeleton-loaders'
import { NearbyResultsGrid } from 'src/views/map-explorer/sidebar/related-results/grid'
import { FlexColumn } from 'src/components/flex-containers'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'

const NoRankPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  const meetsTier = useTier(INSIGHTS_TIER['Rank'])

  return (
    <InsightContainer insight={insight} color={Colors.purpleDark} downloadable={false}>
      <React.Suspense fallback={<FullScreenLoading />}>
        {!meetsTier ? (
          <InsightLocked insight={insight} />
        ) : (
          <FlexColumn gap={Shapes.spacing[4]}>
            <UnavailableMobility />
            <React.Suspense fallback={<GenericLoader variant="rounded" color="light" height={200} width="100%" />}>
              <NearbyResultsGrid hideMobilityToggle />
            </React.Suspense>
          </FlexColumn>
        )}
      </React.Suspense>
    </InsightContainer>
  )
}

export const NoBrandRankInsight: Insight = {
  id: 'no-brand-rank',
  component: NoRankPage,
  name: 'Brand Rank (Mobile Data)',
  nameIcon: Info,
  nameIconColor: Colors.neutral400,
  icon: RankIcon,
  supportedResultTypes: ['address', 'alphamap-location'],
  linkTooltipFile: 'insights-link-performance-benchmarks',
  tier: INSIGHTS_TIER['Rank'],
  paywall: {
    title: 'See Rank Reports in Action',
    description: `Rank isn't available on your current plan. However, you can view full functionality of this feature by viewing an unlocked location or upgrading your plan below.`,
    synopsis: [
      {
        image: rank1.src,
        imagePlaceholder: rank1Placeholder.src,
        title: 'Benchmark Like a Pro',
        description: 'Effortlessly compare locations, identifying top performers and uncovering key market trends.',
      },
      {
        image: rank2.src,
        imagePlaceholder: rank2Placeholder.src,
        title: 'Strategic Insights at Your Fingertips',
        description:
          'Make data-driven decisions with ease, using objective rankings to guide your investment and expansion strategies.',
      },
      {
        image: rank3.src,
        imagePlaceholder: rank3Placeholder.src,
        title: 'Optimize Your Market Position',
        description:
          'Leverage powerful analytics to refine your location strategy and outperform competitors in the market.',
      },
    ],
  },
}
